// Handle functionality of accordion list
class accordionList {
    constructor(element) {
        // Find all necessary elements
        this.element = element;
        this.listWrapper = document.querySelector(`[data-list="wrapper"]`);

        // Get lists
        this.items = element.querySelectorAll(`[data-list="item"]`);

        // Init functionalities if all elements has been found
        if (this.items.length > 0) {
            this.init();
        }
        else {
            console.error("missing elements to properly init accordionList")
        }
    }

    init() {

        // Add functionality to show itemContent on click of item
        this.items.forEach(item => {
            item.addEventListener('click', (e) => {
                e.preventDefault();

                // on click show itemContent 
                this.showContent(item);
            });
        });
    }

    showContent(item) {
        console.log(item);
        let is_active = item.dataset.active;
        let item_id = item.dataset.id;
        let wrapper = item.closest(`[data-list="wrapper"]`);
        console.log(wrapper);
        let itemContent = wrapper.querySelector(`[data-list="content"][data-id="${item_id}"]`);
        let itemContainer = item.closest(`[data-list="item-container"]`);

        // Show or hide click element
        if (is_active == 'true') {
            item.classList.remove("active");
            item.setAttribute("data-active", "false");

            itemContent.classList.remove("active");
            itemContent.setAttribute("data-active", "false");

            itemContainer.classList.remove("active");
        } else {
            item.classList.add("active");
            item.setAttribute("data-active", "true");

            itemContent.classList.add("active");
            itemContent.setAttribute("data-active", "true");

            itemContainer.classList.add("active");
        }

    }
}

window.addEventListener('load', () => {
    // Get all tabs list that need to use this functionality
    const listWrapper = document.querySelectorAll(`[data-list="wrapper"]`);
    if (listWrapper.length > 0) {
        
        listWrapper.forEach(list => {
            // Find all tabs elements
            const listElements = list.querySelectorAll(`[data-list="items"]`);
            
            listElements.forEach(element => {
                // Init functionality for every element
                new accordionList(element);
            })
        })
    }
})